var Component = require("/home/travis/build/tonyhhyip/library/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Security.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-1fac7e8e!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Security.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./assets/js/page/Security.vue
// module id = 64
// module chunks = 0